/**
 * The rollout gate — which branches print through `@rista/printing` instead of v1.
 *
 * The same shape as the payment engine's (`@rista/payments/engine/config`), and it REUSES that
 * package's matcher rather than copying eight lines: two identifiers outside the merchant's
 * control, both lists shipping empty, so the default is v1 and a rollout is a reviewed code change
 * with a deploy behind it. A merchant cannot switch printing engines mid-service.
 *
 * The "is a host registered" half of the gate lives in `index.ts`, which owns that instance — this
 * file holds only the list and the match, so nothing here imports back into index and the two
 * cannot form a cycle.
 */
import { matchesAllowlist, type V2Allowlist } from "@rista/payments/engine/config";

import store from "../redux-store";
import { selectBusinessData } from "./selectors";

/** Ships EMPTY. Adding an entry is the rollout; removing it is the rollback. */
export const PRINTING_ALLOWLIST: V2Allowlist = {
  branchIds: [],
  accountUUIDs: [],
};

/** Is this terminal's branch (or account) on the list? Reads the store when not given one. */
export function branchPrintsThroughEngine(businessData?: any): boolean {
  return matchesAllowlist(businessData ?? selectBusinessData(store.getState()), PRINTING_ALLOWLIST);
}
